import React, { useState, useEffect } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useParams } from "react-router-dom";
import EventHeader from "../components/EventHeader";
import PhotoUpload from "../components/PhotoUpload";
import PhotoGallery from "../components/PhotoGallery";
import AuthModal from "../components/AuthModal";
import { getPhotos } from "../utils/photoApi";

const EventUploadPage = () => {
  const { scrollY } = useScroll();
  const headerY = useTransform(scrollY, [0, 200], [0, -20]);
  const galleryY = useTransform(scrollY, [0, 500], [0, -30]);

  const { eventId } = useParams();
  const [photos, setPhotos] = useState([]);
  const [eventName] = useState("");
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false);

  useEffect(() => {
    // Scroll to top al cargar la página
    window.scrollTo(0, 0);

    // Verificar si el usuario ya está autenticado
    const userName = localStorage.getItem("uploaderName");
    if (userName && userName.trim()) {
      setIsAuthenticated(true);
    } else {
      setShowAuthModal(true);
    }

    const fetchPhotos = async () => {
      try {
        const fetchedPhotos = await getPhotos();
        console.log("Fotos recuperadas:", fetchedPhotos);

        // Validar que fetchedPhotos sea un array
        if (Array.isArray(fetchedPhotos)) {
          setPhotos(fetchedPhotos);
        } else {
          console.error("getPhotos no retornó un array:", fetchedPhotos);
          setPhotos([]);
        }
      } catch (error) {
        console.error("Error al cargar fotos:", error);
        setPhotos([]);
      }
    };
    fetchPhotos();
  }, []);

  const handleAuthenticated = (name) => {
    setIsAuthenticated(true);
    setShowAuthModal(false);
  };

  const handlePhotoUploaded = (newPhoto) => {
    console.log("Nueva foto subida:", newPhoto);
    setPhotos((prev) => [...prev, newPhoto]);
  };

  const handleLike = (photoId) => {
    console.log("Like en foto:", photoId);
  };
  return (
    <>
      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onAuthenticated={handleAuthenticated}
      />

      <motion.div
        className="min-h-screen relative overflow-hidden flex items-center justify-center bg-gradient-to-br from-neutral-ivory via-accent-rose/10 to-neutral-light"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        {/* Decoración de fondo con patrón Talavera */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-10 left-10 w-32 h-32 rounded-full bg-primary blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-40 h-40 rounded-full bg-secondary blur-3xl"></div>
          <div className="absolute top-1/2 left-1/2 w-48 h-48 rounded-full bg-accent-gold blur-3xl"></div>
        </div>

        <div className="relative z-10 w-full">
          <div className="container mx-auto px-2 sm:px-4 max-w-7xl py-4 sm:py-8">
            {!isPhotoModalOpen && (
              <motion.div style={{ y: headerY }}>
                <EventHeader
                  eventName={eventName || "Evento sin nombre"}
                  photoCount={photos.length}
                />
              </motion.div>
            )}
            {isAuthenticated && !isPhotoModalOpen && (
              <PhotoUpload onPhotoUploaded={handlePhotoUploaded} />
            )}
            <motion.div style={{ y: galleryY }}>
              <PhotoGallery
                photos={photos}
                onLike={handleLike}
                onRequestAuth={() => setShowAuthModal(true)}
                onModalOpenChange={setIsPhotoModalOpen}
              />
            </motion.div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default EventUploadPage;
